import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_FEATURE_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  LOGIN_USER_SSO,
} from "./actionTypes";

const initialState = {
  error: false,
  loading: false,
  data: null,
  dataAvailabilities: null,
  loadingSSO: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        error: false,
        loading: true,
        data: null,
      };
      break;
    case LOGIN_USER_SSO:
      state = {
        ...state,
        loadingSSO: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        error: false,
        loading: false,
        data: action.payload,
      };
      break;
    case UPDATE_USER_SUCCESS:
      state = {
        ...state,
        error: false,
        loading: false,
        data: {
          ...state.data,
          user: Object.assign(state.data.user, action.payload),
        },
      };
      break;
    case UPDATE_FEATURE_SUCCESS:
      state = {
        ...state,
        error: false,
        loading: false,
        data: {
          ...state.data,
          features: action.payload,
        },
      };
      break;
    case LOGOUT_USER:
      state = { ...state, error: false, loadingLogout: true, success: false };
      break;
    case LOGOUT_USER_SUCCESS:
      state = {
        ...state,
        error: false,
        loadingLogout: false,
        success: true,
        data: null,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        loadingSSO: false,
        success: false,
      };
      break;
    default:
      state = { ...state, error: false, loading: false };
      break;
  }
  return state;
};

export default login;
